import Crud from './';

class Variations extends Crud {
  constructor(token) {
    super('/appellations/variations', token);
  }
}

export default Variations;
